import { Controller } from 'stimulus';
import toArray from '../helpers/toArray';

class TagManager extends Controller {
  onAcceptCookies() {
    this.loadTags();
  }

  loadTags() {
    const templates = toArray(this.element.querySelectorAll('[data-tag-manager]'));

    templates.forEach((template) => {
      const div = document.createElement('div');

      // In PHP we've encoded the HTML to prevent the browser from interpreting
      // before we actually need it.
      div.innerHTML = TagManager.decodeHtml(template.innerHTML);

      toArray(div.children)
        .map(TagManager.createElementFromChild)
        .forEach((element) => {
          template.insertAdjacentElement('beforebegin', element);
        });

      template.parentNode.removeChild(template);
    });
  }

  static createElementFromChild(child) {
    if (child.tagName === 'SCRIPT') {
      return TagManager.createElementFromScriptChild(child);
    }

    return child;
  }

  static createElementFromScriptChild(child) {
    const script = document.createElement('script');

    // When an external script is called we set it on the script tag and return
    if (child.src) {
      script.src = child.src;
      script.async = true;
      return script;
    }

    // When the script is inline we've to insert the innerHTML in our
    // new script block in order for the browser to execute it.
    const textNode = document.createTextNode(child.innerHTML);
    script.appendChild(textNode);

    return script;
  }

  static decodeHtml(str) {
    return decodeURIComponent(str.replace(/\+/g, ' '));
  }
}

TagManager.targets = [
  //
];

export default TagManager;
